import { applyActiveEffect } from './combatTimeline';

export const SAP_DEFINITION_ID = 'weapon-mastery:sap';
export const SAP_DISADVANTAGE_SOURCE = 'Weapon Mastery: Sap';

const masteryKey = (attack) => String(
  attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || ''
).trim().toLowerCase();

export const isSapMasteryAttack = (attack) => Boolean(
  attack?.kind === 'weapon' && attack?.hasWeaponMastery && masteryKey(attack) === 'sap'
);

// Sap keys off the hit itself. Immunity and every other zero-damage outcome are
// deliberately irrelevant to this predicate.
export const qualifiesForSap = ({ attack, outcome, attackerId, targetId, combatState }) =>
  isSapMasteryAttack(attack) && ['hit', 'critical-hit'].includes(outcome) &&
  Boolean(attackerId && targetId && Number.isInteger(combatState?.turnSequence) && combatState?.activeTurn != null);

export const getActiveSapEffects = (combatState, targetId) =>
  (combatState?.activeEffects || []).filter((effect) =>
    effect?.definitionId === SAP_DEFINITION_ID && effect?.targetCombatantId === targetId);

export const createSapEffect = ({ attackerId, targetId, resolutionId, sourceWeaponInstanceId }) => ({
  id: `sap:${resolutionId}`,
  definitionId: SAP_DEFINITION_ID,
  name: 'Sap · Next Attack Disadvantage',
  icon: '💥',
  userVisible: true,
  sourceCombatantId: attackerId,
  targetCombatantId: targetId,
  sourceResolutionId: resolutionId,
  ...(sourceWeaponInstanceId ? { sourceWeaponInstanceId } : {}),
  expiration: { type: 'sourceTurn', combatantId: attackerId, boundary: 'start', remainingOccurrences: 1 },
  stackKey: `${SAP_DEFINITION_ID}:${attackerId}:${targetId}`,
  stackPolicy: 'refresh',
  description: 'Disadvantage on the next attack roll.',
});

export const applySapEffect = (combatState, input) => applyActiveEffect(combatState, createSapEffect(input));
